module.exports = __webpack_public_path__ + "img/1484584999.f52cc03b.jpg";